import { DevelopQuick } from "../widgets/developQuick/developQuick.js";

let fdDevelopQuick = document.getElementById('fdDevelopQuick');
let opts = {};
let fdDevelopQuickWidget = new DevelopQuick(fdDevelopQuick, opts);